module.exports = __webpack_public_path__ + "static/media/settings.d2a8ccd6.svg";